import { useParams } from 'react-router-dom'

/**
 * Because a common convention is that path/route params are mandatory while query params are optional.
 * But useParams is generic and its return type is Record<string, string | undefined> which is not helpful.
 */
export const useRequiredParams = <T extends Record<string, unknown>>(): T => useParams() as T
